<template>
  <v-footer app absolute inset color="primary white--text">
    <span>
      &copy; {{ new Date().getFullYear() }} —
      <strong>راديو زوارة</strong>
    </span>
  </v-footer>
</template>
<script>
export default {
  name: "AppFooter",
};
</script>
